import type { Movie } from "@/types";

export const movies: Movie[] = [
  {
    id: "m1",
    title: "星海彼岸",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20astronaut%20standing%20before%20a%20glowing%20distant%20galaxy%2C%20deep%20navy%20and%20teal%20tonal%20palette%2C%20simple%20dark%20studio%20background%2C%20dramatic%20rim%20lighting%2C%20minimal%20composition%2C%20high%20detail%20editorial%20film%20art&width=400&height=600&seq=movie-poster-01&orientation=portrait",
    year: 2025,
    rating: 8.7,
    genres: ["科幻", "冒险"],
    region: "国内",
    director: "陈默",
    cast: ["林致远", "苏晚晴", "周牧"],
    duration: "142分钟",
    synopsis: "一艘为人类寻找新家园的星际飞船在航行途中突然失去联系，年轻的领航员江屿必须在孤立无援的深空中做出决定。面对未知的宇宙与内心的恐惧，他逐渐发现，真正遥远的不是星光，而是人心之间的距离。影片以细腻的镜头语言探讨了孤独、信念与回家的意义，是近年来国产科幻的一次野心之作。",
    topic: "年度科幻佳作盘点",
    hot: true,
  },
  {
    id: "m2",
    title: "长安旧梦",
    poster: "https://readdy.ai/api/search-image?query=Historical%20epic%20movie%20poster%20of%20an%20ancient%20Chinese%20warrior%20in%20flowing%20crimson%20armor%20under%20a%20golden%20lantern%20sky%2C%20warm%20amber%20and%20dark%20red%20palette%2C%20simple%20moody%20dark%20background%2C%20cinematic%20lighting%2C%20minimal%20elegant%20film%20art%20composition&width=400&height=600&seq=movie-poster-02&orientation=portrait",
    year: 2024,
    rating: 8.2,
    genres: ["历史", "动作", "剧情"],
    region: "国内",
    director: "徐立",
    cast: ["慕容恪", "柳青", "袁安"],
    duration: "156分钟",
    synopsis: "盛唐末年，一场围绕长安城的暗流悄然涌动。老将与少年在一场误会中并肩，从敌手成为知己，却不得不面对分道扬镳的命运。影片以恢弘的战争场面与克制的叙事，描摹出一个时代的繁华与落寞，让观众在刀光剑影中感受家国与情义的重量。",
    topic: "华语古装佳作精选",
    hot: true,
  },
  {
    id: "m3",
    title: "无声告白",
    poster: "https://readdy.ai/api/search-image?query=Emotional%20drama%20movie%20poster%20of%20a%20young%20woman%20looking%20out%20a%20rainy%20window%2C%20soft%20muted%20blue%20grey%20tones%2C%20simple%20plain%20studio%20background%2C%20soft%20natural%20light%2C%20minimal%20quiet%20composition%2C%20editorial%20film%20photography&width=400&height=600&seq=movie-poster-03&orientation=portrait",
    year: 2025,
    rating: 7.9,
    genres: ["剧情", "家庭"],
    region: "国内",
    director: "何静",
    cast: ["叶知秋", "陆铭", "宋佳"],
    duration: "118分钟",
    synopsis: "一位沉默寡言的母亲与多年未归的女儿在一个寻常的春天重逢。那些没有说出口的话，藏在厨房的饭菜里、藏在旧相册的边角里。影片用平静而克制的日常细节，讲述了一个关于理解与和解的故事，让沉默成为最深情的告白。",
    topic: "现实主义剧情单元",
    hot: false,
  },
  {
    id: "m4",
    title: "深空回响",
    poster: "https://readdy.ai/api/search-image?query=Space%20sci-fi%20movie%20poster%20of%20a%20massive%20ringed%20space%20station%20orbiting%20a%20violet%20deep%20space%20nebula%2C%20cool%20indigo%20and%20silver%20palette%2C%20simple%20dark%20background%2C%20dramatic%20lighting%2C%20minimal%20sleek%20sci-fi%20film%20art&width=400&height=600&seq=movie-poster-04&orientation=portrait",
    year: 2025,
    rating: 8.4,
    genres: ["科幻", "悬疑"],
    region: "欧美",
    director: "Elena Frost",
    cast: ["Marcus Reed", "Nadia Cole", "Tom Hayes"],
    duration: "134分钟",
    synopsis: "一座环绕气态巨行星运行的空间站突然收到来自一百光年外的信号。当科学家们解码出信号的内容，却发现它在重复一段不该存在的历史。影片将硬核科学设定与紧张悬疑节奏结合，带观众走进一个关于时间、记忆与真相的迷宫。",
    topic: "年度科幻佳作盘点",
    hot: true,
  },
  {
    id: "m5",
    title: "城市微光",
    poster: "https://readdy.ai/api/search-image?query=Romantic%20movie%20poster%20of%20a%20couple%20sharing%20an%20umbrella%20on%20a%20neon%20lit%20night%20street%2C%20warm%20amber%20and%20soft%20peach%20tones%2C%20bokeh%20city%20lights%2C%20simple%20blurred%20background%2C%20cinematic%20glow%2C%20minimal%20romantic%20film%20art&width=400&height=600&seq=movie-poster-05&orientation=portrait",
    year: 2024,
    rating: 7.6,
    genres: ["爱情", "都市"],
    region: "国内",
    director: "苏文",
    cast: ["韩承", "程曦", "白露"],
    duration: "110分钟",
    synopsis: "深夜的便利店、末班的公交、同一盏路灯下，两个在城市里孤独打拼的年轻人一次次擦肩而过。影片用温润的镜头记录下平凡生活里的微小光亮，告诉观众即使在最疲惫的夜晚，也总有一束光为你而亮。",
    topic: "都市爱情影单",
    hot: false,
  },
  {
    id: "m6",
    title: "追风少年",
    poster: "https://readdy.ai/api/search-image?query=Inspirational%20sports%20movie%20poster%20of%20a%20young%20cyclist%20racing%20at%20sunrise%20on%20a%20mountain%20road%2C%20energetic%20orange%20and%20green%20palette%2C%20simple%20clean%20background%2C%20dynamic%20motion%20lighting%2C%20minimal%20youthful%20film%20art&width=400&height=600&seq=movie-poster-06&orientation=portrait",
    year: 2023,
    rating: 8.0,
    genres: ["运动", "励志"],
    region: "国内",
    director: "郑昊",
    cast: ["方正", "夏雨", "赵磊"],
    duration: "126分钟",
    synopsis: "来自小城的少年为了一个看似遥远的梦想，加入了不被看好的自行车队。训练场上的汗水、伤病与质疑，让他在一次次跌倒中学会重新站起。影片用热血的赛场与真诚的情感，讲述了一段关于青春、坚持与友情的成长旅程。",
    topic: "青春励志观影指南",
    hot: false,
  },
  {
    id: "m7",
    title: "迷雾山庄",
    poster: "https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%20of%20an%20old%20isolated%20mansion%20shrouded%20in%20heavy%20fog%20at%20night%2C%20cool%20grey%20blue%20and%20deep%20green%20palette%2C%20simple%20dark%20background%2C%20eerie%20moody%20lighting%2C%20minimal%20mysterious%20film%20art&width=400&height=600&seq=movie-poster-07&orientation=portrait",
    year: 2025,
    rating: 8.1,
    genres: ["悬疑", "惊悚"],
    region: "欧美",
    director: "Julian Marsh",
    cast: ["Helen Ward", "Owen Blake", "Rita Stone"],
    duration: "122分钟",
    synopsis: "一场暴风雪将七名互不相识的旅客困在一座与世隔绝的山庄里。当他们发现彼此都与多年前的一桩旧案有关，疑云便在封闭的空间里迅速蔓延。影片用层层反转的剧本和压抑的氛围，将人性的猜忌推向极致。",
    topic: "高分悬疑片推荐",
    hot: true,
  },
  {
    id: "m8",
    title: "樱花之诺",
    poster: "https://readdy.ai/api/search-image?query=Japanese%20romance%20movie%20poster%20of%20a%20couple%20under%20blooming%20cherry%20blossom%20trees%2C%20soft%20pink%20and%20pale%20blue%20palette%2C%20simple%20clean%20sky%20background%2C%20gentle%20natural%20light%2C%20minimal%20tender%20film%20composition&width=400&height=600&seq=movie-poster-08&orientation=portrait",
    year: 2024,
    rating: 7.8,
    genres: ["爱情", "剧情"],
    region: "日韩",
    director: "佐藤悠真",
    cast: ["松本遥", "高桥凌", "小林奈"],
    duration: "115分钟",
    synopsis: "每年樱花盛开时，少年都会在约定的小站等待那个离开的人。随着四季流转，等待本身也成了一种温柔的习惯。影片以诗意的画面和细腻的情感，讲述了一段关于时间、承诺与重逢的纯粹爱情故事。",
    topic: "治愈系爱情片单",
    hot: false,
  },
  {
    id: "m9",
    title: "极夜行动",
    poster: "https://readdy.ai/api/search-image?query=Action%20movie%20poster%20of%20a%20special%20forces%20agent%20in%20tactical%20gear%20during%20polar%20night%2C%20cold%20steel%20blue%20and%20orange%20accents%2C%20simple%20snow%20background%2C%20high%20contrast%20dramatic%20lighting%2C%20minimal%20gritty%20film%20art&width=400&height=600&seq=movie-poster-09&orientation=portrait",
    year: 2025,
    rating: 8.3,
    genres: ["动作", "犯罪"],
    region: "国内",
    director: "程峰",
    cast: ["雷铮", "安琪", "段野"],
    duration: "131分钟",
    synopsis: "在极地漫长的黑暗里，一支秘密小队要完成一场几乎不可能的任务。敌人的追踪、队友的背叛与时间的压迫，让每一步都如履薄冰。影片以凌厉的动作设计和紧张的节奏，呈现了一场惊心动魄的极夜突围。",
    topic: "硬核动作片精选",
    hot: true,
  },
  {
    id: "m10",
    title: "时光信箱",
    poster: "https://readdy.ai/api/search-image?query=Fantasy%20movie%20poster%20of%20an%20antique%20mailbox%20glowing%20with%20warm%20golden%20light%20in%20a%20cozy%20study%2C%20warm%20amber%20and%20soft%20brown%20palette%2C%20simple%20dim%20background%2C%20magical%20soft%20lighting%2C%20minimal%20heartwarming%20film%20art&width=400&height=600&seq=movie-poster-10&orientation=portrait",
    year: 2023,
    rating: 7.7,
    genres: ["奇幻", "剧情"],
    region: "日韩",
    director: "朴成宇",
    cast: ["金宇彬", "李知恩", "崔秀"],
    duration: "108分钟",
    synopsis: "一间老旧的文具店里，有一个能把信寄往过去的信箱。女孩抱着试一试的心情写下第一封信，却意外收到了来自十年前的回信。影片用温柔的奇幻设定，讲述了一个关于遗憾、释怀与珍惜当下的动人故事。",
    topic: "治愈系爱情片单",
    hot: false,
  },
  {
    id: "m11",
    title: "荒原来信",
    poster: "https://readdy.ai/api/search-image?query=Western%20drama%20movie%20poster%20of%20a%20lone%20rider%20on%20horseback%20crossing%20a%20vast%20desert%20at%20dusk%2C%20warm%20ochre%20and%20dusty%20terracotta%20palette%2C%20simple%20wide%20desert%20background%2C%20golden%20hour%20lighting%2C%20minimal%20epic%20film%20art&width=400&height=600&seq=movie-poster-11&orientation=portrait",
    year: 2024,
    rating: 8.0,
    genres: ["剧情", "西部"],
    region: "欧美",
    director: "Samuel Vance",
    cast: ["Jack Monroe", "Clara Webb", "Ben Ortiz"],
    duration: "137分钟",
    synopsis: "在一片荒无人烟的旷野上，一封迟到了二十年的信被送到主人公手中。带着信中的线索，他踏上了一场寻找真相与自我的旅程。影片以广袤的自然景观与克制的叙事，探讨了孤独、救赎与人与土地之间复杂的情感。",
    topic: "文艺观影指南",
    hot: false,
  },
  {
    id: "m12",
    title: "量子迷宫",
    poster: "https://readdy.ai/api/search-image?query=Mind%20bending%20sci-fi%20movie%20poster%20of%20a%20man%20inside%20a%20fractal%20geometric%20corridor%20of%20shifting%20light%2C%20electric%20cyan%20and%20deep%20violet%20palette%2C%20simple%20abstract%20background%2C%20surreal%20lighting%2C%20minimal%20futuristic%20film%20art&width=400&height=600&seq=movie-poster-12&orientation=portrait",
    year: 2025,
    rating: 8.5,
    genres: ["科幻", "悬疑", "惊悚"],
    region: "欧美",
    director: "Elena Frost",
    cast: ["Marcus Reed", "Iris Lang", "David Cole"],
    duration: "128分钟",
    synopsis: "一位物理学家在实验事故后，发现自己被困在不断重复又不完全相同的时空里。每一次循环，他都会失去一段记忆，却离真相更近一步。影片以精妙的叙事结构和震撼的视觉设计，将观众带入一场关于选择与宿命的思维迷宫。",
    topic: "年度科幻佳作盘点",
    hot: true,
  },
];

export const movieTopics = [
  {
    id: "t1",
    title: "年度科幻佳作盘点",
    subtitle: "来自星海深处的十部必看科幻",
    description: "从硬核太空歌剧到烧脑时间循环，精选近年最具想象力与情感深度的科幻作品，带你穿越无人抵达的宇宙边界。",
    movieIds: ["m1", "m4", "m12"],
    cover: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20science%20fiction%20background%20with%20deep%20navy%20nebula%2C%20glowing%20geometric%20planets%20and%20soft%20teal%20light%20streaks%2C%20minimal%20cinematic%20poster%20art%2C%20dramatic%20contrast%2C%20high%20detail%20digital%20illustration&width=1200&height=700&seq=topic-sci-fi&orientation=landscape",
  },
  {
    id: "t2",
    title: "周末治愈系影单",
    subtitle: "让温暖的故事陪你度过慢时光",
    description: "当你疲惫时，总有一部电影愿意轻轻拥抱你。精选爱情与奇幻题材的温柔之作，适合一个人静静看完。",
    movieIds: ["m8", "m10", "m5"],
    cover: "https://readdy.ai/api/search-image?query=Soft%20dreamy%20background%20with%20warm%20amber%20and%20peach%20gradient%20light%2C%20blurred%20bokeh%20particles%20and%20gentle%20colors%2C%20minimal%20cozy%20cinematic%20poster%20art%2C%20calm%20and%20comforting%20mood%2C%20high%20detail&width=1200&height=700&seq=topic-healing&orientation=landscape",
  },
];